/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import { Product } from "@/adapters/productsAdapter";
import { AlertInterface } from "@/lib/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const alertSlice = createSlice({
  name: "alert",
  initialState: {
    deviceLimitExceeded: false,
    paymentFailed: false,
    alerts: [] as AlertInterface[],
    newProduct: undefined as Product | undefined,
  },
  reducers: {
    addAlert(state, action: PayloadAction<AlertInterface>) {
      if (state.alerts.some((alert) => alert.id === action.payload.id)) return;
      state.alerts.push(action.payload);
    },
    removeAlert(state, action: PayloadAction<string>) {
      // S445 bug fix: localStorage.setItem("newUser", "false") was incorrectly
      // placed as the second argument to Array.filter() — Array.filter's second
      // argument is `thisArg`, not a callback. JavaScript evaluates it eagerly
      // as a function call, so newUser was stamped into localStorage on EVERY
      // removeAlert dispatch (payment-failed, device-limit, etc.), not just
      // when the activate-product alert was closed. This caused the first-time
      // buyer welcome/activation prompt to disappear permanently the moment any
      // dashboard alert was dismissed — even if the activation alert was never seen.
      //
      // Correct behaviour: only mark newUser as "seen" when the activate-product
      // alert is the one being removed, so the use-newUser hook stops showing
      // the welcome modal only after the user has actually interacted with it.
      const alertToRemove = state.alerts.find(
        (alert) => alert.id === action.payload,
      );
      if (alertToRemove?.type === "activate-product") {
        localStorage.setItem("newUser", "false");
      }
      state.alerts = state.alerts.filter(
        (alert) => alert.id !== action.payload,
      );
    },
    setNewProduct(state, action: PayloadAction<Product>) {
      state.newProduct = action.payload;
    },
  },
});
export const { addAlert, removeAlert, setNewProduct } = alertSlice.actions;
export default alertSlice.reducer;
